//
import { Service } from '@/services/api2'
import SlSaleDebitNoteModel from '@/models/Sale/SlSaleDebitNote'

/**
 * 
 */
export default class SlSaleDebitNoteService extends Service {

  /**
   * 
   */
  static create(slSaleDebitNote) {
    return slSaleDebitNote
      .toCreate()
      .save()
  }

  /**
   * 
   */
  static createWithPdf(slSaleDebitNote) {
    return this.create(slSaleDebitNote).then(this.pdf)
  }

  /**
   * The api model of service
   * @returns {Object} api model
   */
  model() {
    return SlSaleDebitNoteModel
  }

  /**
   * 
   */
  static pdf(model) {
    model.id = model.id || (model.dte && model.dte.dte ? model.dte.dte.id : null)
    model.number = model.number || (model.dte && model.dte.dte ? model.dte.dte.number : null)
    return model.downloadPdf()
  }
}